<template>
  <v-container fluid>
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <v-divider></v-divider>
    <v-row class="ma-0">
      <v-col cols="12">
        <v-progress-linear 
          rounded 
          height="32" 
          :value="counter.mitLeibvater / (counter.mitLeibvater + counter.ohneLeibvater) * 100"
        >
        Aktueller Stand: {{ counter.mitLeibvater }} von {{ counter.mitLeibvater + counter.ohneLeibvater }} Leibvätern eingetragen ({{ (counter.mitLeibvater / (counter.mitLeibvater + counter.ohneLeibvater) * 100).toFixed(1) }} %).
        </v-progress-linear>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-simple-table dense fixed-header height="calc(100vh - 170px)">
          <thead>
            <tr>
              <th class="semester">Semester</th>
              <!-- <th class="charge">XXX</th>
              <th class="charge">XX</th>
              <th class="charge">X</th>
              <th class="charge">FM</th>
              <th class="charge">XXXX</th> -->
              <th>Receptionen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="semest in semester" :key="semest.semesterID">
              <td width="90px" class="semester"><span>{{ semest.semestername }}</span></td>
              <!-- <td class="charge"><v-btn fab small class="{ semest.xxx }">XXX</v-btn></td>
              <td class="charge"><v-btn fab small class="{ semest.xx }">XX</v-btn></td>
              <td class="charge"><v-btn fab small class="{ semest.x }">X</v-btn></td>
              <td class="charge"><v-btn fab small class="{ semest.FM }">FM</v-btn></td>
              <td class="charge"><v-btn fab small class="{ semest.xxx }">XXXX</v-btn></td> -->
              <td>
                <v-btn class="body-2" min-width="200px" v-for="bbr in semest.receptionen" :key="bbr.ID" text @click="showModal(bbr.id, bbr.leibvater)">
                  <span :class="bbr.leibvater ? 'green--text' : ''" class="text-capitalize">{{ bbr.name }} </span>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="modal"
      width="500"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title
          primary-title
        >
          Leibvater auswählen
        </v-card-title>

        <v-card-text>
          <v-autocomplete hide-details dense outlined :items='bundesbruder' placeholder='Bisher wurde kein Leibvater ausgewählt' v-model='leibvater'></v-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="modal = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        modal: false,
        leibvater: '',
        bbr: [],
        sidenav: false,
        counter: {
          mitLeibvater: 0,
          ohneLeibvater: 0
        }
      }
    },
    computed: {
      bundesbruder () {
        let bundesbruder = []
        let bbrbbr = this.$store.getters['bbrbbr/nurBbrbbr']
        bbrbbr.forEach(item => {
          bundesbruder.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname
          })
        })
        return bundesbruder
      },
      semester () {
        let semester = []
        let art = '1'
        let semesterID = 1
        for (let i = 1945; i <= 2023; i++) {
          if (art === '1') {
            let receptionen = []
            let bundesbruder = this.$store.getters['bbrbbr/nurBbrbbr']
            this.counter.mitLeibvater = 0
            this.counter.ohneLeibvater = 0
            bundesbruder.forEach(bbr => {
              if (bbr.leibvater) {
                this.counter.mitLeibvater++
              } else {
                this.counter.ohneLeibvater++
              }
              if (bbr.receptionsdatum) {
                if (parseInt(bbr.receptionsdatum.slice(0, 4)) === i) {
                  let was = bbr.receptionsdatum.slice(5, 7)
                  if ((was >= 10 && was <= 12)) {
                    receptionen.push({
                      id: bbr.id,
                      name: bbr.nachname + ', ' + bbr.vorname,
                      leibvater: bbr.leibvater
                    })
                  }
                } else if (parseInt(bbr.receptionsdatum.slice(0, 4)) === i + 1) {
                  let was = bbr.receptionsdatum.slice(5, 7)
                  if ((was >= 1 && was <= 3)) {
                    receptionen.push({
                      id: bbr.id,
                      name: bbr.nachname + ', ' + bbr.vorname,
                      leibvater: bbr.leibvater
                    })
                  }
                }
              }
            })
            semester.push({
              semesterID: semesterID,
              semestername: 'WS ' + i,
              xxx: '',
              xx: '',
              x: '',
              FM: 'green',
              xxxx: '',
              receptionen
            })
            art = '0'
          } else {
            let receptionen = []
            let bundesbruder = this.$store.getters['bbrbbr/nurBbrbbr']
            bundesbruder.forEach(bbr => {
              if (bbr.receptionsdatum) {
                if (parseInt(bbr.receptionsdatum.slice(0, 4)) === i) {
                  let was = bbr.receptionsdatum.slice(5, 7)
                  if (was >= 4 && was <= 9) {
                    receptionen.push({
                      id: bbr.id,
                      name: bbr.nachname + ', ' + bbr.vorname,
                      leibvater: bbr.leibvater
                    })
                  }
                }
              }
            })
            semester.push({
              semesterID: semesterID,
              semestername: 'SS ' + i,
              xxx: '',
              xx: '',
              x: '',
              FM: 'green',
              xxxx: '',
              receptionen
            })
            i--
            art = '1'
          }
          semesterID++
        }
        return semester
      }
    },
    methods: {
      showModal (id, leibvater) {
        this.leibvater = ''
        let bbrbbr = this.$store.getters['bbrbbr/nurBbrbbr']
        bbrbbr.forEach(item => {
          if (item.id === id) {
            this.bbr = item
          }
          if (item.id === leibvater) {
            this.leibvater = item.id
          }
        })
        this.modal = true
      },
      save () {
        const changes = {
          id: this.bbr.id,
          leibvater: this.leibvater
        }
        this.$store.dispatch('bbrbbr/updateBbrData', changes)
        this.modal = false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Daten.vue?6ccbc09e